import { CAMPAIGN_SALES_PATHS } from "../components/CampaignSales/campaignSalesRoutes";
import {
  CANONICAL_SALES_PATH,
  LEGACY_SALES_PATHS,
} from "../constants/salesRoutes";

export const PUBLIC_ROUTES = [
  "/",
  "/about",
  "/contact",
  "/contact-instructor",
  "/privacy-policy",
  "/terms",
  CANONICAL_SALES_PATH,
  ...LEGACY_SALES_PATHS,
  ...CAMPAIGN_SALES_PATHS,
  "/reels",
  "/faq",
  "/verify-account",
  "/reset-password",
  "/cart-success",
  "/cart-error",
  "/error",
];
